export interface GestureTrigger {
  name: string;
  patterns: RegExp[];
  chineseWords: string[];
  motion: string;
  fallbackGesture?: string;
}

export const gestureTriggers: GestureTrigger[] = [
  {
    name: 'wave',
    patterns: [
      /\b(hello|hi)\b/i,
      /\b(hey|good\s+morning|good\s+afternoon|good\s+evening|morning|evening)\b/i,
    ],
    chineseWords: [
      '你好',
      '您好',
      '嗨',
      '哈喽',
      '你好啊',
      '早上好',
      '早安',
      '下午好',
      '晚上好',
      '晚安',
    ],
    motion: 'chitose_handwave',
    fallbackGesture: 'wave',
  },
  {
    name: 'nod',
    patterns: [
      /\b(yes|ok|agree|right|correct)\b/i,
      /\b(got\s+it|understood|roger)\b/i,
    ],
    chineseWords: [
      '是的',
      '好的',
      '好',
      '嗯',
      '对',
      '正确',
      '同意',
      '可以',
      '行',
      '明白了',
      '知道了',
      '收到',
    ],
    motion: 'chitose_kime01',
    fallbackGesture: 'nod',
  },
  {
    name: 'surprise',
    patterns: [/\b(wow|amazing|unbelievable|oh my)\b/i],
    chineseWords: ['惊讶', '哇', '哇塞', '震惊', '不可思议', '天哪'],
    motion: 'chitose_kime02',
  },
  {
    name: 'happy',
    patterns: [
      /\b(great|awesome|nice|happy|excellent|fantastic|perfect|cool)\b/i,
    ],
    chineseWords: ['开心', '太棒了', '棒', '赞', '很好', '厉害', '不错', '666'],
    motion: 'chitose_kime01',
  },
  {
    name: 'thanks',
    patterns: [/\b(thanks|thank\s+you)\b/i],
    chineseWords: ['谢谢', '感谢', '谢了'],
    motion: 'chitose_kime01',
  },
  {
    name: 'farewell',
    patterns: [/\b(bye|goodbye|see\s+you)\b/i],
    chineseWords: ['再见', '拜拜', '回见', '告辞'],
    motion: 'chitose_handwave',
    fallbackGesture: 'wave',
  },
  {
    name: 'question',
    patterns: [/\b(what|why|how|where|when)\b/i],
    chineseWords: ['吗', '呢'],
    motion: 'chitose_kime02',
  },
];

export function checkGestureTrigger(
  message: string,
  triggeredSet: Set<string>
): GestureTrigger | null {
  const lowerMessage = message.toLowerCase();

  for (const trigger of gestureTriggers) {
    if (triggeredSet.has(trigger.name)) continue;

    const patternMatch = trigger.patterns.some((p) => p.test(lowerMessage));
    const chineseMatch = trigger.chineseWords.some((w) => message.includes(w));
    const questionMatch =
      trigger.name === 'question' &&
      (message.includes('?') || message.includes('？'));

    if (patternMatch || chineseMatch || questionMatch) {
      return trigger;
    }
  }

  return null;
}
